<div class="w-full py-3 px-2 sm:px-4">
  <!-- Header Section -->
  <div class="flex flex-col sm:flex-row sm:items-center justify-between mb-4 gap-3">
    <div class="flex items-center justify-start gap-1 lg:gap-2">
      <!-- Back Button SVG (clickable) -->
    <svg class="size-6 cursor-pointer" [routerLink]="['/product-creation']" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">
    
        <mask id="mask0_848_1764" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#C19725" />
        </mask>
        <g mask="url(#mask0_848_1764)">
            <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
        </g>
    </svg>
      <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/stock/stock.png" alt="Stock" />
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444 whitespace-nowrap">Design Products</span>
      <!-- <h2 class="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-800">Design Products</h2> -->
    </div>
    <div class="w-full sm:w-auto">
      <a
        routerLink="/product-creation"
        class="block cursor-pointer px-3 py-1.5 text-xs sm:text-sm lg:text-base font-semibold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center transition-all"
      >
        Add Product
      </a>
    </div>
  </div>

  <!-- Filter Controls Section -->
  <div
    class="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4"
  >
    <!-- Filter Grid -->
    <div
      class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 items-end justify-start gap-3 w-full lg:w-auto"
    >
      <div class="relative flex items-center gap-1 sm:gap-2">
        <label
          for="rowFilter"
          class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
        >
          Rows :
        </label>
        <div class="relative w-full">
          <select
            id="rowFilter"
            [(ngModel)]="visibleRowCount"
            (change)="updateVisibleRows()"
            class="w-full border border-dcdcdc rounded-[5px] p-1 text-xs sm:text-sm appearance-none !bg-none pr-8 focus:outline-none focus:ring-0 focus:border-c19725 bg-white"
          >
            <option
              *ngFor="let count of [5, 10, 20, 30, 40, 50, 100]"
              [value]="count"
            >
              {{ count }}
            </option>
          </select>
          <div
            class="absolute inset-y-0 right-1.5 flex items-center pointer-events-none"
          >
            <svg
              width="10"
              height="5"
              viewBox="0 0 14 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z"
                fill="#C19725"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="flex items-center gap-1 sm:gap-2">
        <label
          for="globalSearch"
          class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
        >
          Search :
        </label>
        <input
          id="globalSearch"
          type="text"
          [(ngModel)]="globalSearchText"
          (ngModelChange)="filterTable()"
          placeholder="Search all columns..."
          class="w-full border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm focus:outline-none focus:ring-0 focus:border-c19725"
          autocomplete="off"
        />
      </div>
      <!-- ================= FROM DATE ================= -->
  <div class="flex items-center gap-1 sm:gap-2">
    <label
      for="startDate"
      class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
    >
      From :
    </label>

    <input
      id="startDate"
      type="date"
      [(ngModel)]="startDate"
      (change)="filterTable()"
      class="w-full border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm focus:outline-none focus:ring-0 focus:border-c19725"
    />
  </div>

  <!-- ================= TO DATE ================= -->
  <div class="flex items-center gap-1 sm:gap-2">
    <label
      for="endDate"
      class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
    >
      To :
    </label>

    <input
      id="endDate"
      type="date"
      [(ngModel)]="endDate"
      (change)="filterTable()"
      class="border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm focus:outline-none focus:ring-0 focus:border-c19725 w-full"
    />
  </div>
    </div>

    <!-- Action Buttons Wrapped -->
    <div
      class="flex items-center flex-wrap justify-center md:justify-end gap-2 mt-2 lg:mt-0 w-full lg:w-auto"
    >
      <button
        class="flex-1 md:flex-none flex items-center justify-center gap-1 text-[#F20707] border-1 border-[#F20707] bg-[#fff6f3] font-medium text-xs lg:text-sm px-2 2xl:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadPDF()"
      >
      <svg class="size-4 xl:hidden" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 16L11.2929 16.7071L12 17.4142L12.7071 16.7071L12 16ZM13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4L13 4ZM5.29289 10.7071L11.2929 16.7071L12.7071 15.2929L6.70711 9.29289L5.29289 10.7071ZM12.7071 16.7071L18.7071 10.7071L17.2929 9.29289L11.2929 15.2929L12.7071 16.7071ZM13 16L13 4L11 4L11 16L13 16Z" fill="#F20707"></path> <path d="M5 21L19 21" stroke="#F20707" stroke-width="2"></path> </g></svg>
        <span class="hidden xl:block">Download</span>PDF
      </button>
      <button
        class="flex-1 md:flex-none flex items-center justify-center gap-1 text-[#029921] border-1 border-[#029921] bg-[#e6ffe6] font-medium text-xs lg:text-sm px-2 2xl:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadExcel()"
      >
         <svg class="size-4 xl:hidden" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 16L11.2929 16.7071L12 17.4142L12.7071 16.7071L12 16ZM13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4L13 4ZM5.29289 10.7071L11.2929 16.7071L12.7071 15.2929L6.70711 9.29289L5.29289 10.7071ZM12.7071 16.7071L18.7071 10.7071L17.2929 9.29289L11.2929 15.2929L12.7071 16.7071ZM13 16L13 4L11 4L11 16L13 16Z" fill="#029921"></path> <path d="M5 21L19 21" stroke="#029921" stroke-width="2"></path> </g></svg>
        <span class="hidden xl:block">Download</span>Excel
      </button>
      <button
        class="flex-1 md:flex-none flex items-center justify-center gap-1 text-[#0720EC] border-1 border-[#0720EC] bg-[#E8E6FF] font-medium text-xs lg:text-sm px-2 2xl:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadJSONAll()"
      >
        <svg class="size-4 xl:hidden" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 16L11.2929 16.7071L12 17.4142L12.7071 16.7071L12 16ZM13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4L13 4ZM5.29289 10.7071L11.2929 16.7071L12.7071 15.2929L6.70711 9.29289L5.29289 10.7071ZM12.7071 16.7071L18.7071 10.7071L17.2929 9.29289L11.2929 15.2929L12.7071 16.7071ZM13 16L13 4L11 4L11 16L13 16Z" fill="#0720EC"></path> <path d="M5 21L19 21" stroke="#0720EC" stroke-width="2"></path> </g></svg>
        <span class="hidden xl:block">Download</span>JSON
      </button>
      <button
        class="flex-1 md:flex-none flex items-center justify-center gap-1 text-[#00ad94] border-1 border-[#00ad94] bg-[#e5fffb] font-medium text-xs lg:text-sm px-2 2xl:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadCSV()"
      >
        <svg class="size-4 xl:hidden" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 16L11.2929 16.7071L12 17.4142L12.7071 16.7071L12 16ZM13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4L13 4ZM5.29289 10.7071L11.2929 16.7071L12.7071 15.2929L6.70711 9.29289L5.29289 10.7071ZM12.7071 16.7071L18.7071 10.7071L17.2929 9.29289L11.2929 15.2929L12.7071 16.7071ZM13 16L13 4L11 4L11 16L13 16Z" fill="#00ad94"></path> <path d="M5 21L19 21" stroke="#00ad94" stroke-width="2"></path> </g></svg>
        <span class="hidden xl:block">Download</span>CSV
      </button>

      <!-- Visibility Dropdown -->
      <div class="relative inline-block text-left flex-1 md:flex-none">
        <button
          (click)="toggleDropdown()"
          class="w-full text-[#B92185] border-1 border-[#B92185] bg-[#FFE1F5] font-medium text-xs lg:text-sm px-2 2xl:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        >
          Visibility
        </button>

        <div
          *ngIf="showDropdown"
          class="absolute z-50 mt-2 p-4 bg-white border rounded shadow-2xl right-0 sm:-left-24 w-64 max-h-80 overflow-y-auto"
        >
          <p class="font-bold text-sm mb-2 border-b pb-1">Visible Columns:</p>

          <label
            *ngFor="let field of selectedFields"
            class="flex items-center gap-2 text-sm mb-2 cursor-pointer hover:bg-gray-50 p-1 rounded"
          >
            <input
              type="checkbox"
              [(ngModel)]="field.selected"
              (change)="onFieldToggle(field)"
              autocomplete="off"
              class="rounded text-c19725"
            />
            {{ field.label }}
          </label>

          <div class="mt-3 border-t pt-2 flex flex-col gap-2">
            <button (click)="selectAllFields()" class="text-xs text-blue-600 hover:underline text-left">Select All</button>
            <button (click)="deselectAllFields()" class="text-xs text-red-800 hover:underline text-left">Deselect All</button>
            <button (click)="restoreColumnSelection()" class="text-xs text-gray-600 hover:underline text-left">Restore Defaults</button>

            <button
              (click)="showDropdown=false"
              class="mt-2 bg-c19725 text-white text-xs font-bold py-2 rounded-[5px] transition"
            >
              Apply Changes
            </button>
          </div>
        </div>
      </div>
      <button
        (click)="printTable()"
        class="flex-1 md:flex-none text-[#5606b6] border-1 border-[#5606b6] bg-[#ecddff] font-medium text-xs lg:text-sm px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
      >
        Print
      </button>
    </div>
  </div>

  <!-- Main Table Section -->
  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar border border-[#D9D9D9] rounded-md mt-6 shadow-sm">
    <table
      class="w-full table border-collapse border-spacing-0 bg-white overflow-hidden"
    >
      <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
        <tr>
          <th
            class="p-3 font-medium text-center border-r border-gray-300 w-12"
          >
            No.
          </th>
          <th
            *ngFor="let field of selectedFields"
            [hidden]="!field.selected"
            class="p-2 font-medium text-left border-r border-gray-300"
          >
            <div class="flex flex-col gap-1 w-32 sm:w-48 lg:w-64">
              <input
                type="text"
                [(ngModel)]="searchValues[field.key]"
                (click)="$event.stopPropagation()"
                (ngModelChange)="filterTable()"
                [attr.placeholder]="'Filter ' + field.label"
                class="border border-dcdcdc p-1.5 rounded-[5px] text-[10px] w-full focus:outline-none focus:border-c19725 font-normal"
                autocomplete="off"
              />

              <div
                class="text-xs font-bold flex items-center gap-1 cursor-pointer select-none uppercase tracking-tight"
                (click)="sortBy(field.key)"
              >
                {{ field.label }}
                <svg
                  *ngIf="sortKey === field.key"
                  class="w-3 h-3 text-c19725"
                  viewBox="0 0 24 24"
                >
                  <path
                    *ngIf="sortDirection === 'asc'"
                    d="M12 8l6 6H6z"
                    fill="currentColor"
                  />
                  <path
                    *ngIf="sortDirection === 'desc'"
                    d="M12 16l-6-6h12z"
                    fill="currentColor"
                  />
                </svg>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody class="text-xs sm:text-sm lg:text-base">
        <ng-container *ngIf="paginatedDesignProductList.length > 0; else noData">
          <ng-container *ngFor="let item of paginatedDesignProductList; let i = index">
            <ng-container *ngIf="(item?.metal_data?.length || item?.stone_data?.length || item?.packaging_data?.length) && item?.['latest_price_info']?.['purchase_price']">
              <tr class="hover:bg-gray-50 transition-colors">
                <!-- Serial Number -->
                <td class="p-3 border-r border-b border-[#D9D9D9] text-center text-gray-500 font-medium">
                  {{ (currentPage - 1) * itemsPerPage + i + 1 }}
                </td>

                <!-- Dynamic Fields -->
                <ng-container *ngFor="let field of selectedFields">
                  <td *ngIf="field.selected" class="p-3 border-r border-b border-[#D9D9D9] align-top">
                    <ng-container [ngSwitch]="field.key">
                      <ng-container *ngSwitchCase="'image'">
                        <div class="flex justify-center">
                          <img
                            [src]="item['product_image'] || item['product_image_2'] || item['product_image_3'] || item['product_image_4'] || item['product_image_5']"
                            alt="Product Image"
                            class="product-image w-10 h-10 sm:w-12 sm:h-12 object-contain rounded border border-gray-100 shadow-sm"
                          />
                        </div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'metal_data'">
                        <div *ngIf="item?.metal_data?.length; else noMetalData" class="overflow-hidden rounded border border-gray-200">
                          <table class="w-full text-[10px] sm:text-xs">
                            <thead>
                              <tr class="bg-gray-100 border-b border-gray-200">
                                <th class="py-1 px-2 text-left border-r border-gray-200">Code</th>
                                <th class="py-1 px-2 text-left border-r border-gray-200">Name</th>
                                <th class="py-1 px-2 text-center border-r border-gray-200">Piece WT</th>
                                <th class="py-1 px-2 text-center border-r border-gray-200">Silver WT</th>
                                <th class="py-1 px-2 text-center">Qty</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let metal of item.metal_data" class="border-b border-gray-100 last:border-b-0">
                                <td class="py-1 px-2 border-r border-gray-100">{{ metal.code }}</td>
                                <td class="py-1 px-2 border-r border-gray-100 max-w-[100px] truncate">{{ metal.artical_name }}</td>
                                <td class="py-1 px-2 border-r border-gray-100 text-center">{{ metal.per_piece_weight }}</td>
                                <td class="py-1 px-2 border-r border-gray-100 text-center">{{ metal.total_weight }}</td>
                                <td class="py-1 px-2 text-center font-bold">{{ metal.quantity }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <ng-template #noMetalData>
                          <span class="text-gray-400 italic">N/A</span>
                        </ng-template>
                      </ng-container>

                      <ng-container *ngSwitchCase="'stone_data'">
                        <div *ngIf="item?.stone_data?.length; else noStoneData" class="overflow-hidden rounded border border-gray-200">
                          <table class="w-full text-[10px] sm:text-xs">
                            <thead>
                              <tr class="bg-gray-100 border-b border-gray-200">
                                <th class="py-1 px-2 text-left border-r border-gray-200">Code</th>
                                <th class="py-1 px-2 text-left border-r border-gray-200">Name</th>
                                <th class="py-1 px-2 text-center">Qty</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let stone of item.stone_data" class="border-b border-gray-100 last:border-b-0">
                                <td class="py-1 px-2 border-r border-gray-100">{{ stone.code }}</td>
                                <td class="py-1 px-2 border-r border-gray-100 max-w-[100px] truncate">{{ stone.stone_name }}</td>
                                <td class="py-1 px-2 text-center font-bold">{{ stone.quantity }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <ng-template #noStoneData>
                          <span class="text-gray-400 italic">N/A</span>
                        </ng-template>
                      </ng-container>

                      <ng-container *ngSwitchCase="'packaging_data'">
                        <div *ngIf="item?.packaging_data?.length; else noPackagingData" class="overflow-hidden rounded border border-gray-200">
                          <table class="w-full text-[10px] sm:text-xs">
                            <thead>
                              <tr class="bg-gray-100 border-b border-gray-200">
                                <th class="py-1 px-2 text-left border-r border-gray-200">Code</th>
                                <th class="py-1 px-2 text-left border-r border-gray-200">Name</th>
                                <th class="py-1 px-2 text-center">Qty</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let packaging of item.packaging_data" class="border-b border-gray-100 last:border-b-0">
                                <td class="py-1 px-2 border-r border-gray-100">{{ packaging.product_code }}</td>
                                <td class="py-1 px-2 border-r border-gray-100 max-w-[100px] truncate">{{ packaging.material_name }}</td>
                                <td class="py-1 px-2 text-center font-bold">{{ packaging.quantity }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <ng-template #noPackagingData>
                          <span class="text-gray-400 italic">N/A</span>
                        </ng-template>
                      </ng-container>

                      <ng-container *ngSwitchCase="'silver_rate'">
                        <span class="font-medium text-gray-700">{{ item['latest_price_info']?.['silver_rate'] || 'N/A' }}</span>
                      </ng-container>

                      <ng-container *ngSwitchCase="'silver_weight'">
                        <span class="font-medium text-gray-700">{{ item['latest_price_info']?.['silver_wt'] || 'N/A' }}</span>
                      </ng-container>

                      <ng-container *ngSwitchCase="'total_price'">
                        <span class="font-bold text-c19725">₹ {{ item['latest_price_info']?.['purchase_price'] || 'N/A' }}</span>
                      </ng-container>

                      <ng-container *ngSwitchCase="'labour_charges'">
                        <span class="font-medium text-gray-700">{{ item['latest_price_info']?.['labour_charges'] || 'N/A' }}</span>
                      </ng-container>

                      <ng-container *ngSwitchCase="'total_thread'">
                        <span class="font-medium text-gray-700">{{ item['latest_price_info']?.['thread_price'] || 'N/A' }}</span>
                      </ng-container>

                      <ng-container *ngSwitchDefault>
                        <span class="text-gray-700">{{ item[field.key] }}</span>
                      </ng-container>
                    </ng-container>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>

        <!-- No Data Template -->
        <ng-template #noData>
          <tr>
            <td [attr.colspan]="selectedFields.length + 2" class="text-center py-10 text-gray-400 italic">
              No products found matching your search.
            </td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>

  <!-- Pagination Controls -->
  <div
    class="flex flex-col sm:flex-row items-center justify-between border-t border-gray-200 bg-white py-4 gap-4"
  >
    <div class="text-xs text-gray-500 italic">
      Page {{currentPage}} of {{totalPages || 1}}
    </div>
    <div class="flex sm:flex-1 sm:items-center sm:justify-end">
      <div>
        <nav
          class="isolate inline-flex gap-1 sm:gap-2 -space-x-px rounded-md"
          aria-label="Pagination"
        >
          <!-- Previous Button -->
          <button
            (click)="goToPreviousPage()"
            [disabled]="currentPage === 1"
            class="relative inline-flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0 disabled:opacity-30 disabled:pointer-events-none transition-all"
          >
            <span class="sr-only">Previous</span>
            <svg
              class="size-5 md:size-6"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>

          <!-- Page Buttons -->
          <div class="flex gap-1 overflow-x-auto max-w-[150px] sm:max-w-none no-scrollbar">
            <ng-container *ngFor="let page of pageNumbers">
              <button
                (click)="goToPage(page)"
                [class.bg-c19725]="currentPage === page"
                [class.text-white]="currentPage === page"
                class="relative z-10 inline-flex items-center justify-center min-w-[32px] md:min-w-[36px] h-8 md:h-9 rounded-[5px] text-sm font-bold text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 transition-all"
              >
                {{ page }}
              </button>
            </ng-container>
          </div>

          <!-- Next Button -->
          <button
            (click)="goToNextPage()"
            [disabled]="currentPage === totalPages"
            class="relative inline-flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0 disabled:opacity-30 disabled:pointer-events-none transition-all"
          >
            <span class="sr-only">Next</span>
            <svg
              class="size-5 md:size-6"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </nav>
      </div>
    </div>
  </div>
</div>